module.exports = __webpack_public_path__ + "amcharts/images/dragIconRectSmall.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRectSmall.png
// module id = 238
// module chunks = 0